import { useEffect, useMemo } from "react";

interface Props {
  blob: Blob;
  fileName: string;
}

export function DocumentPreview({ blob, fileName }: Props) {
  const url = useMemo(() => URL.createObjectURL(blob), [blob]);

  useEffect(() => {
    return () => URL.revokeObjectURL(url);
  }, [url]);

  return (
    <iframe src={url} title={fileName} style={{ width: "100%", height: "100%", border: "none", display: "block" }} />
  );
}
